{
  "form": {
    "fields": {
      "name": "Nom",
      "confirm_name": "Confirmer le nom",
      "confirm_email": "Confirmer adresse e-mail",
      "username": "Nom d'utilisateur",
      "email": "Email",
      "password": "Mot de passe",
      "host": "Hôte",
      "format": "Format",
      "beta": "Bêta",
      "enabled": "Activé",
      "port": "Port",
      "description": "Description",
      "id": "ID",
      "uuid": "UUID",
      "identifier": "Identifiant",
      "author": "Auteur",
      "ip": "IP",
      "alias": "Pseudonyme",
      "ports": "Ports",
      "phpmyadmin_url": "uRL de phpMyAdmin",
      "name_first": "Prénom",
      "name_last": "Nom",
      "preferences": {
        "language": "Langue",
        "navbar_position": "Position de la barre de navigation"
      },
      "new_email": "Nouvelle adresse e-mail",
      "current_password": "Mot de passe actuel",
      "new_password": "Nouveau mot de passe",
      "new_password_confirmation": "Répétez le nouveau mot de passe",
      "root_admin": "Administrateur",
      "support_op": "Support",
      "support_op_bypass": "Support Bypass",
      "external_id": "ID Externe",
      "token": "Jeton",
      "memo": "Note",
      "allowed_ips": "IP Autorisés",
      "connection_address": "Adresse de connexion",
      "connections_from": "Connecté(e) à partir de",
      "folder_name": "Nom du dossier",
      "file_name": "Nom du fichier",
      "edition": "Édition",
      "version": "Version",
      "repository": "URL du dépôt",
      "branch": "Branche",
      "access_token": "Jeton d'accès personnel",
      "workshop_url": "URL du Workshop",
      "show_non_high_severity": "Afficher les résultats non filtrés",
      "time_offset": "Décalage horaire",
      "cron_minute": "Minute",
      "cron_hour": "Heure",
      "cron_day_of_week": "Jour de la semaine",
      "cron_day_of_month": "Jour du mois",
      "action": "Action",
      "payload": "Charge utile",
      "panel_url": "URL du panel",
      "application_api_key": "Clé API de l'application",
      "users": "Utilisateurs",
      "content": "Contenu",
      "type": "Type",
      "fqdn": "FQDN",
      "display_fqdn": "Afficher le FQDN",
      "maintenance_mode": "Mode Maintenance",
      "location": "Localisation",
      "egg": "Egg",
      "nest": "Nest",
      "docker_image": "Image Docker",
      "startup": "Commande de démarrage",
      "cpu": "CPU",
      "memory": "Mémoire",
      "swap": "Swap",
      "disk": "Disque",
      "block_io_proportion": "Block IO Proportion",
      "overallocate": "Surallocation",
      "database_limit": "Limite de base de données",
      "allocation_limit": "Limite d'allocation",
      "backup_megabytes_limit": "Taille limite de sauvegarde",
      "category": "Catégorie",
      "script_install": "Installer un script",
      "script_uninstall": "Désinstaller le script",
      "config_from": "Copier le paramètre depuis",
      "config_logs": "Configuration du Journal",
      "config_startup": "Notification de démarrage",
      "custom_config": "Configuration Personnalisée",
      "config_files": "Fichiers de configuration",
      "stop_command": "Commande de d'arrêt",
      "copy_script_from": "Copier le script depuis",
      "script_container": "Conteneur de script",
      "script_entry": "Point d’entrée noyau",
      "env_variable": "Variable d'environnement",
      "default_value": "Valeur par défaut",
      "tickable": "Tickable",
      "user_viewable": "Visible par les utilisateurs",
      "user_editable": "Modifiable par les utilisateurs",
      "rules": "Règles",
      "allocation": "Allocation",
      "primary_allocation": "Allocation principale",
      "secondary_allocations": "Allocations secondaires",
      "add_allocations": "Ajouter une Allocation additionnelle",
      "remove_allocations": "Supprimer une Allocation additionnelle",
      "server_owner": "Propriétaire du serveur",
      "startup_command": "Commande de démarrage",
      "default_startup_command": "Commande de démarrage par défaut",
      "node": "Node",
      "backup": "Sauvegarder",
      "force": "Forcer",
      "start_on_completion": "Démarrer le serveur une fois installé",
      "skip_scripts": "Ignorer le script d'installation",
      "oom_disabled": "Désactiver le tueur d'OOM",
      "domain_name": "Nom de Domaine",
      "nest_identifiers": "Identificateurs de nids",
      "egg_identifiers": "Identificateurs de nids",
      "root_record": "Enregistrement racine",
      "branding": {
        "name": "Nom de l'entreprise"
      },
      "misc": {
        "databases_allow_random": "Activer le déploiement de la base de données sur des nodes aléatoires",
        "required_2fa": "Authentification à deux facteurs obligatoire"
      },
      "default_locale": "Langue par défaut",
      "og": {
        "site_name": "Nom du site",
        "title": "Titre",
        "description": "Description",
        "image": "URL de l'image"
      },
      "whmcs": {
        "enabled": "WHMCS SSO activé",
        "button_text": "Texte du bouton de connexion",
        "url": "URL du WHMCS",
        "client_id": "ID client WHMCS",
        "client_secret": "Secret client WHMCS",
        "api_id": "ID de l'API WHMCS",
        "api_secret": "Secret de l'API WHMCS"
      },
      "variable_value": "{env} variable"
    },
    "validation_error": "Il y a l'erreur suivante: | Il y a les erreurs suivantes:",
    "validator": {
      "accepted": "La valeur doit être acceptée | Le champ {attribute} doit être accepté",
      "active_url": "La valeur n'est pas une URL valide | Le champ {attribute} n'est pas une URL valide",
      "after": "La valeur doit être une date après {date} | Le champ {attribute} doit être une date après {date}",
      "after_or_equal": "La valeur doit être une date postérieure ou égale à {date} | Le champ {attribute} doit être une date postérieure ou égale à {date}",
      "alpha": "La valeur ne peut contenir que des lettres | Le champ {attribute} ne peut contenir que des lettres",
      "alpha_dash": "La valeur ne peut contenir que des lettres, des chiffres et des tirets. Le champ {attribute} ne peut contenir que des lettres, des chiffres et des tirets",
      "alpha_num": "La valeur ne peut contenir que des lettres et des chiffres | Le champ {attribute} ne peut contenir que des lettres et des chiffres",
      "array": "La valeur doit être un tableau | Le champ {attribute} doit être un tableau",
      "before": "La valeur doit correspondre à une date antérieure à {date} | Le champ {attribute} doit correspondre à une date antérieure à {date}",
      "before_or_equal": "La valeur doit être une date antérieure ou égale à {date} | Le champ {attribute} doit être une date antérieure ou égale à {date}",
      "between": {
        "numeric": "La valeur doit se situer entre {min} et {max} | Le champ {attribute} doit se situer entre {min} et {max}",
        "file": "La valeur doit être comprise entre {min} et {max} kilobytes | Le champ {attribute} doit être compris entre {min} et {max} kilobytes",
        "string": "La valeur doit être comprise entre {min} et {max} caractères. Le champ {attribute} doit être compris entre {min} et {max} caractères",
        "array": "La valeur doit être comprise entre {min} et {max} items | Le champ {attribute} doit être compris entre {min} et {max} items"
      },
      "boolean": "La valeur doit être true ou false | Le champ {attribute} doit être true ou false",
      "confirmed": "La confirmation de la valeur ne correspond pas. La confirmation du champ {attribute} ne correspond pas",
      "date": "La valeur n'est pas une date valide | Le champ {attribute} n'est pas une date valide",
      "date_format": "La valeur ne correspond pas au format {format} | Le champ {attribute} ne correspond pas au format {format}",
      "different": "La valeur et {other} doivent être différents | Le champ {attribute} et {other} doivent être différents",
      "digits": "La valeur doit être {digits} chiffres | Le champ {attribute} doit être {digits} chiffres",
      "digits_between": "La valeur doit être comprise entre {min} et {max} chiffres. Le champ {attribute} doit être compris entre {min} et {max} chiffres",
      "dimensions": "La valeur a des dimensions d'image invalides | Le champ {attribute} a des dimensions d'image invalides",
      "distinct": "La valeur a une valeur en double | Le champ {attribute} a une valeur en double",
      "email": "E-mail invalide | E-mail invalide pour le champ {field}",
      "exists": "La valeur est invalide | Le champ {attribute} est invalide",
      "file": "La valeur doit être un fichier | Le champ {attribute} doit être un fichier",
      "filled": "La valeur est obligatoire | Le champ {attribute} est obligatoire",
      "image": "La valeur doit être une image | Le champ {attribute} doit être une image",
      "in": "La valeur est invalide | Le champ {attribute} est invalide",
      "in_array": "La valeur n'existe pas dans {other} | Le champ {attribute} n'existe pas dans {other}",
      "integer": "La valeur doit être un entier valide | Le champ {field} doit être un entier valide.",
      "ip": "La valeur doit être une adresse IP valide | Le champ {attribute} doit être une adresse IP valide",
      "json": "La valeur doit être une chaîne JSON valide. Le champ {attribute} doit être une chaîne JSON valide",
      "max": {
        "numeric": "La valeur ne peut être supérieure à {max} | Le champ {attribute} ne peut être supérieur à {max}",
        "file": "La valeur ne doit pas être supérieure à {max} kilobytes | Le champ {attribute} ne doit pas être supérieur à {max} kilobytes",
        "string": "La valeur ne peut être supérieure à {max} caractères | Le champ {attribute} ne peut être supérieur à {max} caractères",
        "array": "La valeur ne peut être supérieure à {max} items | Le champ {attribute} ne peut être supérieur à {max} items"
      },
      "mimes": "La valeur doit être un fichier de type : {values} | Le champ {attribute} doit être un fichier de type : {values}",
      "mimetypes": "La valeur doit être un fichier de type : {values} | Le champ {attribute} doit être un fichier de type : {values}",
      "min": {
        "numeric": "La valeur doit être au moins égale à {min} | Le champ {attribute} doit être au moins égal à {min}",
        "file": "La valeur doit être au moins égale à {min} kilobytes | Le champ {attribute} doit être au moins égal à {min} kilobytes",
        "string": "La valeur doit être au moins {min} caractères | Le champ {attribute} doit être au moins {min} caractères",
        "array": "La valeur doit être au moins {min} items | Le champ {attribute} doit être au moins {min} items"
      },
      "not_in": "La valeur est invalide | Le champ {attribute} est invalide",
      "numeric": "La valeur doit être un nombre. Le champ {attribute} doit être un nombre",
      "present": "La valeur doit être présente | Le champ {attribute} doit être présent",
      "regex": "Valeur invalide",
      "required": "Ce champ est obligatoire | Champ manquant {field}",
      "required_if": "La valeur est obligatoire lorsque {other} est {value} | Le champ {attribute} est obligatoire lorsque {other} est {value}",
      "required_unless": "La valeur est requise sauf si {other} est dans {values} | Le champ {attribute} est obligatoire, sauf si {other} est dans {values}",
      "required_with": "La valeur est obligatoire lorsque {values} est présent | Le champ {attribute} est obligatoire lorsque {values} est présent",
      "required_with_all": "La valeur est obligatoire lorsque {values} est présent | Le champ {attribute} est obligatoire lorsque {values} est présent",
      "required_without": "La valeur est obligatoire lorsque {values} n'est pas présent | Le champ {attribute} est obligatoire lorsque {values} n'est pas présent",
      "required_without_all": "La valeur est obligatoire lorsque aucun des champs {values} n'est présent. Le champ {attribute} est obligatoire lorsque aucun des champs {values} n'est présent",
      "same": "La valeur et {other} doivent correspondre | Le champ {attribute} et {other} doivent correspondre",
      "size": {
        "numeric": "La valeur doit être {size} items | Le champ {attribute} doit être {size} items",
        "file": "La valeur doit être {size} kilobytes | Le champ {attribute} doit être {size} kilobytes",
        "string": "La valeur doit être {size} caractères | Le champ {attribute} doit être {size} caractères",
        "array": "La valeur doit être {size} items | Le champ {attribute} doit être {size} items"
      },
      "string": "La valeur doit être une chaîne de caractères. Le champ {attribute} doit être une chaîne de caractères",
      "timezone": "La valeur doit être une zone valide | Le champ {attribute} doit être une zone valide",
      "unique": "La valeur a déjà été prise. Le champ {attribute} a déjà été pris.",
      "uploaded": "La valeur n'a pas pu être téléchargée. Le champ {attribute} n'a pas pu être téléchargé",
      "url": "La valeur est invalide | Le champ {attribute} est invalide"
    }
  },
  "table": {
    "labels": {
      "key": "Clé",
      "memo": "Note",
      "last_used": "Dernière utilisation",
      "created": "Créé",
      "uuid": "UUID",
      "id": "ID",
      "email": "Email",
      "name": "Nom",
      "description": "Description",
      "owner": "Propriétaire",
      "connection": "Connexion",
      "username": "Nom d'utilisateur",
      "password": "Mot de passe",
      "2fa": "Authentification à deux facteurs",
      "downloads": "Téléchargements",
      "queued": "En file d’attente",
      "tasks": "Tâches",
      "last_run": "Dernière exécution",
      "next_run": "Prochaine Exécution",
      "file_name": "Nom du fichier",
      "size": "Taille",
      "created_at": "Créé le",
      "migrated_at": "Migré le",
      "last_modified": "Dernière modification",
      "allocation": "Allocations",
      "fqdn": "FQDN",
      "ip": "IP",
      "alias": "Pseudonyme",
      "port": "Port",
      "plan": "Plan",
      "domain": "Domaine",
      "licensed_to": "Licence accordée à",
      "expires": "Expire",
      "addons": "Add-ons",
      "version": "Version",
      "category": "Catégorie",
      "active": "Actif",
      "content": "Contenu",
      "host": "Hôte",
      "databases": "Bases de données ",
      "node": "Nœuds",
      "server": "Serveurs",
      "connections_from": "Connecté(e) à partir de",
      "nodes": "Nœuds",
      "servers": "Serveurs",
      "eggs": "Eggs",
      "location": "Localisation",
      "cpu": "CPU",
      "memory": "Mémoire",
      "disk": "Disque",
      "assigned_to": "Assigné à",
      "internal_identifier": "Identificateur interne",
      "external_identifier": "Identifiant Externe",
      "service": "Service",
      "block_io_weight": "Block IO Weight",
      "backup_size_limit": "Taille limite de sauvegarde",
      "default_connection": "Connexion par défaut",
      "connection_alias": "Adresse de connexion",
      "domain_name": "Nom de Domaine"
    }
  }
}
